import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Afficher après un petit délai pour ne pas gêner
      setTimeout(() => setShow(true), 1500);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      functional: true,
      analytics: true,
      date: new Date().toISOString()
    }));
    setShow(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      functional: false,
      analytics: false,
      date: new Date().toISOString()
    }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-lg z-50 pointer-events-none"
      >
        <div className="glass-card p-5 shadow-2xl pointer-events-auto">
          <div className="flex items-start gap-3">
            <div className="p-2.5 rounded-xl bg-gradient-to-br from-violet-500/20 to-pink-500/20 hidden sm:block shrink-0">
              <Cookie size={22} weight="duotone" className="text-violet-400" />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2 mb-2">
                <h3 className="text-base font-semibold text-white/90 font-sans">Cookies</h3>
                <button
                  onClick={acceptEssential}
                  className="p-1.5 text-white/40 hover:text-white/70 transition-colors rounded-lg hover:bg-white/5"
                  aria-label="Fermer"
                >
                  <X size={18} />
                </button>
              </div>
              <p className="text-sm text-white/50 mb-3 leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience.{' '}
                <Link to="/cookies" className="text-violet-400 hover:text-violet-300 transition-colors">
                  En savoir plus
                </Link>
              </p>
              
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={acceptAll}
                  className="px-4 py-2 bg-gradient-to-r from-violet-500 to-pink-500 hover:opacity-90 rounded-lg text-sm font-medium transition-all"
                  data-testid="accept-all-cookies"
                >
                  Accepter
                </button>
                <button
                  onClick={acceptEssential}
                  className="px-4 py-2 bg-white/[0.06] hover:bg-white/[0.1] border border-white/[0.1] rounded-lg text-sm font-medium transition-all"
                  data-testid="accept-essential-cookies"
                >
                  Refuser
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
